import { smoothScrollIntoView } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setValuationFiltersModalOpened } from '../../actions/page';
import { trackAboutReportImageClick, trackAboutReportShow } from '../../analytics';
import { AboutReport } from '../../components/AboutReport';
import { useLocalContext } from '../../utils/applicationContext';

interface IAboutReportContainerProps {
  className?: string;
}

export const AboutReportContainer: React.VFC<IAboutReportContainerProps> = ({ className }) => {
  const { formRef } = useLocalContext();
  const dispatch = useDispatch();

  const onItemClickHandler = React.useCallback(() => {
    const formOnPage = formRef?.current;

    trackAboutReportImageClick();

    /** Если на странице встроена форма, то произойдет скролл к ней */
    if (formOnPage) {
      smoothScrollIntoView(formOnPage, 15);
    } else {
      /** Иначе на странице должна быть модалка с формой, произойдет ее открытие */
      dispatch(setValuationFiltersModalOpened(true));
    }
  }, [dispatch, formRef]);

  return <AboutReport className={className} onItemClick={onItemClickHandler} onView={trackAboutReportShow} />;
};
